
import React, { useEffect, useRef } from 'react';

const CookieDeclaration: React.FC = () => {
    const containerRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const container = containerRef.current;
        if (!container) return;

        // Clear previous content
        container.innerHTML = '';

        // Create script element
        const script = document.createElement('script');
        script.id = 'CookieDeclaration';
        script.src = 'https://consent.cookiebot.com/0155a657-7141-495d-b1e9-509e174d85f7/cd.js';
        script.type = 'text/javascript';
        script.async = true;

        // Append to container
        container.appendChild(script);

        return () => {
            // Use the captured local variable for cleanup
            if (container) {
                container.innerHTML = '';
            }
        };
    }, []);

    return (
        <div ref={containerRef} className="cookie-declaration-container bg-gray-800/30 p-4 rounded-lg mt-6" />
    );
};

export default CookieDeclaration;
